import { View } from 'es6/components/view'
import { BaseVideoView } from 'es6/views/base-video-view'
import { LicenceGoodsView } from './licence-goods-view'
import { okoPush } from 'helpers/oko-helpers'
import 'es6/libs/owl-carousel'

/**
 * Вид страницы "О компании".
 * @param {string} el Элемент вида
 */
class AboutView extends View {
  /** @inheritDoc */
  constructor (options) {
    super({
      ...options,
      events: {
        'click .control-play': 'playVideo',
      },
    })
  }

  /** @inheritDoc */
  run (options) {
    this.isMobile = Boolean(options.isMobile)
    this._initChildViews()
    if (this.isMobile) {
      this._initVideoEvents()
      this._initPointCarousel()
    } else {
      this._initNewsCarousel()
    }
    if (this.childViews.videoView && this.childViews.videoView.player) {
      this.childViews.videoView.player.on('ended', () => {
        this.$('.video-wrapper').addClass('not_display')
        this.$('.video-preview-img').show()
      })
    }
  }

  /**
   * Отправка в око событий запуска плеера
   * @private
   */
  _initVideoEvents () {
    let interval
    let isFirstPlay = true
    this.videoElem.on('play', () => {
      if (isFirstPlay) {
        isFirstPlay = false
        okoPush({
          'n': 'video',
          'time': this.videoElem.get(0).currentTime.toFixed(0),
        })
      }
      okoPush({
        'n': 'video',
        'action': 'play',
      })
      interval = setInterval(() => {
        okoPush({
          'n': 'video',
          'time': this.videoElem.get(0).currentTime.toFixed(0),
        })
      }, 10000)
    })
    this.videoElem.on('pause', () => {
      clearInterval(interval)
      okoPush({
        'n': 'video',
        'action': 'pause',
      })
    })
    this.videoElem.on('ended', () => {
      clearInterval(interval)
      okoPush({
        'n': 'video',
        'action': 'ended',
      })
    })
  }

  /**
   * Инициализация дочерних видов.
   * @private
   */
  _initChildViews () {
    const videoSrc = this.$('.video-wrapper video').attr('src')

    this.childViews.licenceGoodsView = new LicenceGoodsView({
      el: '.about-page-license-goods',
      isMobile: this.isMobile,
    })
    if (!this.isMobile) {
      this.childViews.videoView = new BaseVideoView({
        templateName: '#video-template',
        el: this.$('.video-wrapper'),
      })
      this.childViews.videoView.render(videoSrc)
    } else {
      // Нативный плеер браузера (при videojs на iPhone наблюдаются проблемы)
      this.videoElem = this.$('.video-wrapper video')
    }
  }

  /**
   * Инициализация point карусели.
   * @private
   */
  _initPointCarousel () {
    this.$('.js-point-carousel').owlCarousel({
      dots: true,
      nav: false,
      slideBy: 1,
      responsive: {
        0: {
          items: 1,
        },
        720: {
          items: 2,
        },
      },
      mouseDrag: false,
    })
  }

  /**
   * Инициализация новостной карусели.
   * @private
   */
  _initNewsCarousel () {
    this.$('.js-news-carousel').owlCarousel({
      dots: false,
      slideBy: 1,
      responsive: {
        0: {
          items: 4,
          nav: true,
        },
        1280: {
          items: 6,
          nav: true,
        },
        1440: {
          items: 5,
          nav: true,
        },
      },
      mouseDrag: false,
      margin: 32,
    })
  }

  /**
   * Проигрывание видео.
   * @param {DOM} currentTarget
   */
  playVideo ({ currentTarget }) {
    const thumbnail = this.$(currentTarget).parent()
    const videoWrapper = this.$('.video-wrapper')
    thumbnail.hide()
    videoWrapper.removeClass('not_display')
    if (this.isMobile) {
      this.videoElem.get(0).play()
      this.videoElem.on('ended', () => {
        thumbnail.show()
        videoWrapper.addClass('not_display')
      })
    } else {
      this.childViews.videoView.player.play()
    }
  }
}

export default AboutView
